import React, { useContext } from "react";
import AuthImage from "assets/images/unsplash.jpg";
import { ToastContainer } from "react-toastify";
import { classNames } from "helpers/ClassNameHelper";
import { AccessibilityContext } from "views/AccessibilityContext";
interface Props {
    header: React.ReactNode;
    footer: React.ReactNode;
}
export const AccountLayout: React.FC<Props> = ({ children, footer, header }) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <>
            <div className="container">
                <div className="grid">
                    <img
                        className={classNames("image grid-image", lowVision && "filter-grayscale")}
                        src={AuthImage}
                        alt=""
                    />
                    <div className="grid-content">
                        {header}
                        <main>{children}</main>
                        {footer}
                    </div>
                </div>
                <ToastContainer position="top-center" />
            </div>
        </>
    );
};
